import { Link } from "react-router-dom";
import { OihMark } from "./OihMark";

export default function Footer() {
  return (
    <footer className="border-t border-heritage bg-parchment mt-16">
      <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-3">
            <OihMark size={40} tone="light" />
            <div>
              <div className="font-display text-lg text-navy leading-tight">Office of Ismaili Heritage</div>
              <div className="text-[10px] text-muted-h tracking-[0.15em] uppercase">Canada</div>
            </div>
          </div>
          <p className="text-sm text-ink-soft leading-relaxed max-w-md">
            A community-led initiative to gather, preserve, and share the material and oral
            heritage of the Ismaili community across generations, continents, and traditions.
          </p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-muted-h mb-3 font-semibold">Explore</div>
          <ul className="space-y-2 text-sm text-ink-soft">
            <li><Link to="/collection" className="hover:text-navy">Heritage Collection</Link></li>
            <li><Link to="/about" className="hover:text-navy">About the Project</Link></li>
            <li><Link to="/participate" className="hover:text-navy">Share Your Heritage</Link></li>
            <li><Link to="/contact" className="hover:text-navy">Contact the Team</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-muted-h mb-3 font-semibold">Community</div>
          <ul className="space-y-2 text-sm text-ink-soft">
            <li><Link to="/register" className="hover:text-navy">Create Account</Link></li>
            <li><Link to="/login" className="hover:text-navy">Sign In</Link></li>
            <li><Link to="/contact" className="hover:text-navy">Get Help</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-heritage py-4 text-center text-xs text-muted-h">
        © {new Date().getFullYear()} Ismaili Tariqah and Religious Education Board (ITREB) — Office of Ismaili Heritage
      </div>
    </footer>
  );
}
